import { createFileRoute } from "@tanstack/react-router";
import { PlannedMealsIntentNavigate } from "@corpuscomplete/web/modules/common/components/scope-intent-navigate";

export const Route = createFileRoute("/_authenticated/planned-meals")({
  component: PlannedMealsIntentNavigate,
});
